<template>
    <div id="add-funds-page">
        <div class="container">
            <div class="savings">
                <h4>Savings</h4>
                <p class="amount">{{ savingsAmount|currency }}</p>
            </div>
            <div class="swipe up" >
                <i class="fas fa-angle-right fa-rotate-270"></i>
                <p>swipe up to<br>move to savings</p>
            </div>
            <div class="input" v-hammer:swipe.vertical="handleSwipe">
                <currency-input v-model="transferAmount" min="1" max="99999" />
                <p>Amount to Move</p>
            </div>
            <div class="swipe down">
                <p>swipe down to<br>move to checking</p>
                <i class="fas fa-angle-right fa-rotate-90"></i>
            </div>
            <div class="checking">
                <h4>Checking</h4>
                <p class="amount">{{ checkingAmount|currency }}</p>
            </div>
            <div class="buttons">
                <router-link class="button" to="/main/transfers">Set Up Automatic Transfers</router-link>
                <router-link class="button" to="/main/transfer-history">View Transfer History</router-link>
            </div>
        </div>
        <savings-tips />
        <audio ref="sound">
            <source src="../assets/deposit.mp3" type="audio/mp3">
        </audio>
    </div>
</template>
<script>
import CurrencyInput from '../components/CurrencyInput.vue'
import SavingsTips from '../components/SavingsTips.vue'

import {mapGetters, mapState} from 'vuex'
import {randomChoice} from '../fakeData.js'

const AudioCtx = window.AudioContext || window.webkitAudioContext
const ctx = new AudioCtx();

export default {
    name: 'add-funds',
    components: {CurrencyInput, SavingsTips},
    data() {
        return {
            transferAmount: '50.00',
            track: null,
        }
    },
    computed: {
        ...mapGetters(['activeCheckingAccount', 'activeSavingsAccount']),
        savingsAmount: {
            get() {
                return Number(this.activeSavingsAccount.balances[0].amount)
            }, 
            set(val) {
                this.$store.dispatch('setSavingsAmount', val)
            }
        },
        checkingAmount: {
            get() {
                return Number(this.activeCheckingAccount.balances[0].amount)
            }, 
            set(val) {
                this.$store.dispatch('setCheckingAmount', val)
            }
        },
    },
    methods: {
        handleSwipe(event) {
            this.$refs.sound.cloneNode(true).play()

            let from, to;
            let n = Number(this.transferAmount)

            if (event.type == 'swipeup') {
                this.savingsAmount += Number(n)
                this.checkingAmount -= Number(n)

                from = 'Checking'
                to = 'Savings'
            }
            else if (event.type == 'swipedown') {
                this.checkingAmount += Number(n)
                this.savingsAmount -= Number(n)

                from = 'Savings'
                to = 'Checking'
                n = -n
            }

            this.$store.dispatch('logTransfer', {
                transactionDate: new Date(),
                from: from,
                to: to,
                description: `From ${from} to ${to}`,
                transactionAmount: n,
            })
        },
    },
    created() {
        if (!this.activeSavingsAccount) {
            this.$router.push('/main/account-select')
            return
        }
    },
    mounted() {
        this.track = ctx.createMediaElementSource(this.$refs.sound)
        this.track.connect(ctx.destination)
    },
}
</script>
<style lang="scss">
#add-funds-page {
    flex: 1 0 auto;
    background-image: linear-gradient(to bottom, #25e6bb 0%, #0a8de5 100%);

        display: flex;
        flex-flow: column nowrap;

    .container {
        flex: 1 0 100%;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: space-around;

        h4 {
            margin-bottom: 0;
            font-weight: normal;
            text-transform: uppercase;
        }
        .amount {
            padding: 0 32px;
            margin: 0;
            font-size: 32px;
            font-weight: bold;
        }

        .input {
            background: rgba(255, 255, 255, 0.75);
            border-radius: 32px;
            padding: 32px;
            text-align: center;

            input {
                width: 10ch;
                background: transparent;
                text-align: center;
                border: 0;
                border-bottom: solid black 1px;
                
                font-size: 36px;
                font-weight: bold;

                &:focus {
                    box-shadow: none;
                    outline: none;
                }
            }
        }

        .swipe {
            padding: 0 32px;
            i {
                color: white;
                font-size: 48px;
            }
            p {
                font-size: 10px;
                margin: 0;
            }
            
        }

        .buttons {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            width: 95vmin;
            max-width: 340px;
            margin: 0 auto 16px;

            .button {
                display: inline-block;
                color: black;
                background-image: linear-gradient(to bottom, #EBECEC 0%, #ebecec 36%, #D8D8D7 100%);

                border-radius: 12px;

                font-weight: bold;
                text-shadow: 0 0 1px white;

                text-decoration: none;
                font-size: 10px;
                padding: 10px 20px;

                &:first-child {
                    margin-right: 8px;
                }
            }
        }
    }
    audio {
        display: none;
    }
}
</style>
